import { useState } from "react";
import { squareTabs, topicCards } from "@/mocks/homeData";

export default function TopicSquare() {
  const [active, setActive] = useState(squareTabs[0]);
  const list = topicCards.filter((c) => c.zone === active);

  return (
    <section id="square" className="bg-background-100/80 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col gap-2 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="mb-3 inline-flex items-center gap-2 rounded-full bg-background-50 px-3 py-1 text-xs font-medium tracking-wider text-primary-700 ring-1 ring-primary-100">
              <i className="ri-community-line text-primary-500"></i>
              分区浏览
            </span>
            <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-[34px]">
              话题广场
            </h2>
            <p className="mt-3 text-sm text-foreground-600 md:text-base">
              按圈子逛，找准你想围观的那片瓜田。
            </p>
          </div>
        </div>

        {/* segmented control */}
        <div className="mt-6 flex flex-wrap gap-2">
          {squareTabs.map((t) => (
            <button
              key={t}
              onClick={() => setActive(t)}
              className={`whitespace-nowrap rounded-full px-5 py-2 text-sm transition-colors ${
                active === t
                  ? "bg-primary-500 font-medium text-background-50"
                  : "border border-background-200 bg-background-50 text-foreground-700 hover:border-primary-200 hover:text-primary-700"
              }`}
            >
              {t}
            </button>
          ))}
        </div>

        {/* cards */}
        <div className="mt-6 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {list.map((c) => (
            <article
              key={c.title}
              className="group cursor-pointer overflow-hidden rounded-2xl border border-background-200 bg-background-50 transition-colors hover:border-primary-200"
            >
              <div className="relative h-44 w-full overflow-hidden sm:h-40">
                <img
                  src={c.img}
                  alt={c.title}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 rounded-full bg-foreground-950/60 px-2.5 py-1 text-[11px] text-background-50 backdrop-blur">
                  {c.tag}
                </span>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="mb-2 line-clamp-2 text-sm font-semibold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700 md:text-[15px]">
                  {c.title}
                </h3>
                <p className="mb-4 line-clamp-2 text-[13px] leading-relaxed text-foreground-600">
                  {c.summary}
                </p>
                <div className="flex items-center gap-4 border-t border-background-100 pt-3 text-xs text-foreground-500">
                  <span className="inline-flex items-center gap-1.5">
                    <i className="ri-eye-line text-secondary-600"></i>
                    {c.views}
                  </span>
                  <span className="inline-flex items-center gap-1.5">
                    <i className="ri-chat-3-line text-primary-500"></i>
                    {c.replies}
                  </span>
                  <span className="ml-auto text-primary-600 opacity-0 transition group-hover:opacity-100">
                    去看看 <i className="ri-arrow-right-line"></i>
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}